import WarningAmberIcon from '@mui/icons-material/WarningAmber';
import { Chip, useTheme } from '@mui/material';
import { orange } from '@mui/material/colors';
import cn from 'classnames';
import * as React from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { ReactComponent as InventoryIcon } from '../../assets/images/icon-inventory.svg';
import { NO_LOW_INVENTORY_ITEMS_MESSAGE } from '../../constants/inventories';
import { fetchLowInventoryItemsRequest } from '../../store/actions/inventories';
import { selectShouldShowLowInventoryWarning } from '../../store/selectors/shell';
import { BUTTON_BUTTON } from '../../types/forms';
import { IApiError, NotificationListEnum } from '../../types/shell';
import notification from '../../utils/notification';

import styles from './LowInventoryMenuItem.module.scss';

interface IProps {
  className?: string;
  onClick?: () => void;
}

const LowInventoryMenuItem = ({ className, onClick }: IProps) => {
  const { sass, palette } = useTheme();
  const dispatch = useDispatch();

  const hasWarning = useSelector(selectShouldShowLowInventoryWarning);

  const handleFetchLowInventoryItems = React.useCallback(() => {
    const successLowInventoriesToast = () => {
      notification.success(NotificationListEnum.Success, {
        content: NO_LOW_INVENTORY_ITEMS_MESSAGE,
      });
    };

    const errorLowInventoriesToast = (error: IApiError) => {
      notification.error(NotificationListEnum.Error, {
        content: error.message,
      });
    };

    dispatch(
      fetchLowInventoryItemsRequest({
        showModal: true,
        resolve: successLowInventoriesToast,
        reject: errorLowInventoriesToast,
      }),
    );
  }, [dispatch]);

  return (
    <button
      className={cn(styles.container, className)}
      type={BUTTON_BUTTON}
      data-action="low_inventory_btn"
      onClick={() => {
        handleFetchLowInventoryItems();
        onClick?.();
      }}
    >
      <div className={styles.icons}>
        <InventoryIcon className={styles.icon} />
      </div>
      <span className={styles.label}>Low Inventory</span>
      {hasWarning ? (
        <Chip
          icon={<WarningAmberIcon />}
          label="Low "
          color="warning"
          size="small"
          sx={{
            color: sass.ebony,
            marginLeft: 1.5,
            backgroundColor: orange[50],
            border: `1px solid ${palette.common.white}`,
            '& .MuiChip-icon': { color: palette.warning.main, marginRight: '0 !important' },
          }}
        />
      ) : null}
    </button>
  );
};

export default LowInventoryMenuItem;
